require([
    "common/formUtils"
],
function (formUtils) {

    const MODAL_SELECTOR = "#product-selection";

    let whatsLoaded = "";
    let productsCount = 0;

    function displayProductSelection(whichProducts) {
        if (whatsLoaded === whichProducts && productsCount == 1) {
            navigateToFirstProduct();
            return;
        }
        if (whatsLoaded !== whichProducts) {
            fetchProductsAsync(whichProducts);
        }
        $(MODAL_SELECTOR).modal("show");   // display modal
    }

    function fetchProductsAsync(whichProducts) {
        $(MODAL_SELECTOR + " .spinner-wrapper").removeClass("d-none");   // show spinner
        let postData = { SystemItemId: $(MODAL_SELECTOR).data("systemItemId"), WhichProducts: whichProducts };
        formUtils.useToken(postData);
        $.ajax({
            type: "POST",
            url: "/customapi/Product/ProductSelectionData",
            dataType: "text",
            data: postData,
            success: function (data) {
                // fill the product tiles into DOM
                $(MODAL_SELECTOR + " .product-selection-products").html(data);
                whatsLoaded = whichProducts;
                // analyse how many we have
                productsCount = $(MODAL_SELECTOR + " .product-tile").length;
                if (productsCount > 1) {
                    // display the products
                    $(MODAL_SELECTOR + " .spinner-wrapper").addClass("d-none");  // hide spinner
                    $(MODAL_SELECTOR + " .product-selection-title").removeClass("d-none");
                    $(MODAL_SELECTOR + " .product-selection-text").removeClass("d-none");
                    $(MODAL_SELECTOR + " .product-selection-products").removeClass("d-none");
                } else if (productsCount === 1) {
                    navigateToFirstProduct();
                } else if (productsCount === 0) {
                    $(MODAL_SELECTOR + " .spinner-wrapper").addClass("d-none");  // hide spinner
                    $(MODAL_SELECTOR + " .product-selection-products").text("There are no products defined. Please try again later or call customer service for help.");
                }
            },
            error: function (jq, status, errorThrown) {
                $(MODAL_SELECTOR + " .spinner-wrapper").addClass("d-none");  // hide spinner
                $(MODAL_SELECTOR + " .product-selection-products").removeClass("d-none").text("We're very sorry, but there were problems with fetching the products. Please try again later or call customer service for help.");
                console.log("ERROR in fetching products. Status=" + status + " " + jq.status + " Message=" + errorThrown + " " + jq.responseText);
            },
            complete: function () {
            }
        });
    }

    function hideProductSelection() {
        $(MODAL_SELECTOR).modal("hide");
    }

    function navigateToFirstProduct() {
        window.location = $(MODAL_SELECTOR + " .product-tile a").attr("href");
    }

    window.DisplayProductSelection = displayProductSelection;
    window.HideProductSelection = hideProductSelection;    
});

define("ProductSelection/productSelection", function(){});

